import {
  ChevronUp,
  Edit,
  Eye,
  RotateCcw,
  Trash2,
} from "feather-icons-react/build/IconComponents";
import React, { useState } from "react";
import { Link } from "react-router-dom";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { setToogleHeader } from "../../../../core/redux/action";
import ImageWithBasePath from "../../../../core/img/imagewithbasebath";
import { useDispatch, useSelector } from "react-redux";
import Table from "../../../../core/pagination/datatable";
import Swal from "sweetalert2";
import ViewJobSkill from "./ViewJobSkill";
import EditJobSkill from "./EditJobSkill";
import AddJobSkill from "./AddJobSkill";

const JobSkills = () => {
  const dataSource = useSelector(
    (state) => state.rootReducer.applicant_tracking_job_skills_data
  );
  const [viewObj, setViewObj] = useState([]);
  const [editObj, setEditObj] = useState([]);

  const handleDeleteConfirmation = () => {
    Swal.fire({
      title: "Are you sure?",
      text: "This action cannot be undone!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "No, cancel",
    }).then((result) => {
      if (result.isConfirmed) {
        console.log("Item deleted");
        Swal.fire("Deleted!", "Your item has been deleted.", "success");
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire("Cancelled", "Your item is safe :)", "info");
      }
    });
  };

  const dispatch = useDispatch();
  const data = useSelector((state) => state.rootReducer.toggle_header);

  const renderTooltip = (props) => (
    <Tooltip id="pdf-tooltip" {...props}>
      Pdf
    </Tooltip>
  );
  const renderExcelTooltip = (props) => (
    <Tooltip id="excel-tooltip" {...props}>
      Excel
    </Tooltip>
  );

  const renderRefreshTooltip = (props) => (
    <Tooltip id="refresh-tooltip" {...props}>
      Refresh
    </Tooltip>
  );
  const renderCollapseTooltip = (props) => (
    <Tooltip id="refresh-tooltip" {...props}>
      Collapse
    </Tooltip>
  );

  const columns = [
    {
      title: "Skill",
      dataIndex: "skill",
      sorter: (a, b) => a.skill.length - b.skill.length,
      render: (text) =>
        text?.length > 20 ? `${text.substring(0, 20)}...` : text,
    },
    {
      title: "Category",
      dataIndex: "category",
      sorter: (a, b) => a.category.length - b.category.length,
      render: (text) =>
        text?.length > 20 ? `${text.substring(0, 20)}...` : text,
    },
    {
      title: "Description",
      dataIndex: "description",
      sorter: (a, b) => a.description.length - b.description.length,
      render: (text) =>
        text?.length > 30 ? `${text.substring(0, 30)}...` : text,
    },

    {
      title: "Status",
      dataIndex: "status",
      sorter: (a, b) => a.status.length - b.status.length,
      render: (text) => {
        const status = text?.toLowerCase() === "active";
        return (
          <span className={`badge ${status ? "bg-success" : "bg-danger"}`}>
            {status ? "Active" : "Inactive"}
          </span>
        );
      },
    },
    {
      title: "Created On",
      dataIndex: "created_date",
      sorter: (a, b) => a.created_date.length - b.created_date.length,
    },

    {
      title: "Action",
      dataIndex: "action",
      render: (text, record) => (
        <>
          <Link
            className="action-set"
            to="#"
            data-bs-toggle="dropdown"
            aria-expanded="true"
          >
            <i className="fa fa-ellipsis-v" aria-hidden="true" />
          </Link>
          <ul className="dropdown-menu">
            <li>
              <Link
                to="#"
                className="dropdown-item"
                data-bs-toggle="offcanvas"
                data-bs-target="#offcanvasRightViewReg"
                aria-controls="offcanvasRightViewReg"
                onClick={() => setViewObj(record)}
              >
                <Eye className="info-img" />
                View
              </Link>
            </li>
            <li>
              <Link
                to="edit-sales.html"
                className="dropdown-item"
                data-bs-toggle="offcanvas"
                data-bs-target="#offcanvasRightEditReg"
                aria-controls="offcanvasRightEditReg"
                onClick={() => setEditObj(record)}
              >
                <Edit className="info-img text-info" />
                Edit
              </Link>
            </li>
            <li>
              <Link
                className="dropdown-item mb-0"
                onClick={handleDeleteConfirmation}
              >
                <Trash2 className="info-img text-danger" />
                Delete
              </Link>
            </li>
          </ul>
        </>
      ),
    },
  ];

  return (
    <div className="page-wrapper">
      <div className="content">
        <div className="page-header">
          <div className="add-item d-flex">
            <div className="page-title">
              <nav aria-label="breadcrumb">
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="/applicantTracking/dashboard">
                      <i className="fas fa-home fa-lg" />
                    </Link>
                  </li>
                  <h4 className="breadcrumb-item " aria-current="page">
                    Skills List
                  </h4>
                </ol>
              </nav>
              <h6>Manage your Skills here</h6>
            </div>
          </div>
          <ul className="table-top-head">
            <li>
              <OverlayTrigger placement="top" overlay={renderTooltip}>
                <Link>
                  <ImageWithBasePath src="assets/img/icons/pdf.svg" alt="img" />
                </Link>
              </OverlayTrigger>
            </li>
            <li>
              <OverlayTrigger placement="top" overlay={renderExcelTooltip}>
                <Link data-bs-toggle="tooltip" data-bs-placement="top">
                  <ImageWithBasePath
                    src="assets/img/icons/excel.svg"
                    alt="img"
                  />
                </Link>
              </OverlayTrigger>
            </li>

            <li>
              <OverlayTrigger placement="top" overlay={renderRefreshTooltip}>
                <Link data-bs-toggle="tooltip" data-bs-placement="top">
                  <RotateCcw />
                </Link>
              </OverlayTrigger>
            </li>
            <li>
              <OverlayTrigger placement="top" overlay={renderCollapseTooltip}>
                <Link
                  data-bs-toggle="tooltip"
                  data-bs-placement="top"
                  id="collapse-header"
                  className={data ? "active" : ""}
                  onClick={(e) => {
                    e.preventDefault();
                    dispatch(setToogleHeader(!data));
                  }}
                >
                  <ChevronUp />
                </Link>
              </OverlayTrigger>
            </li>
          </ul>
          <div className="page-btn">
            <Link
              to="#"
              data-bs-toggle="offcanvas"
              data-bs-target="#offcanvasRightNewJobSkill"
              aria-controls="offcanvasRightNewJobSkill"
              className="btn btn-primary"
            >
              <i className="ti ti-circle-plus me-1"></i>
              New Skill
            </Link>
          </div>
        </div>
        <div className="card table-list-card">
          <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
            <div className="search-set"></div>
            <div className="d-flex table-dropdown my-xl-auto right-content align-items-center flex-wrap row-gap-3">
              <div className="dropdown me-2">
                <Link
                  to="#"
                  className="dropdown-toggle btn btn-white btn-md d-inline-flex align-items-center"
                  data-bs-toggle="dropdown"
                >
                  Status
                </Link>
                <ul className="dropdown-menu  dropdown-menu-end p-3">
                  <li>
                    <Link to="#" className="dropdown-item rounded-1">
                      All
                    </Link>
                  </li>
                  <li>
                    <Link to="#" className="dropdown-item rounded-1">
                      Active
                    </Link>
                  </li>
                  <li>
                    <Link to="#" className="dropdown-item rounded-1">
                      Inactive
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div className="card-body">
            <div className="table-responsive">
              <Table columns={columns} dataSource={dataSource} />
            </div>
          </div>
        </div>
      </div>
      <>
        <ViewJobSkill viewObj={viewObj} />
        <EditJobSkill editObj={editObj} />
        <AddJobSkill />
      </>
    </div>
  );
};

export default JobSkills;
